import {createTheme} from "@mui/material";
import landingBg from "assets/img/landing-bg.jpg";

const fontFamily = ["Khand", "sans-serif"].join(",");

declare module "@mui/material/styles" {
	// allow configuration using `createTheme`
	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface ThemeOptions {
		[key: string]: unknown;
	}
}

const themeObject = {
	color: {
		primary: "#202020",
		secondary: "#FF00FF",
		tertiary: "#ffffff",
		error: "#A82727",
		footerLink: "#676767",
		header: "#ffffff",
		headerLinkHover: "#1c1c1c",
		headerSubLinksItemTitle: "#b5262f",
		headerSubLink: "#1c1c1c",
		headerSubLinkHover: "#b5262f",
		card: "#525252",
		footer: "#ffffff",
		linkColor: "#848484",
		linkBorderColor: "#cccccc",
		active: "#00FFFF",
	},
	background: {
		primary: "#ffffff",
		secondary: "#FF00FF",
		tertiary: "#202020",
		quaternary: "#545456",
		footer: "#000000",
		header: "#191919",
		headerLinkHover: "#f0f0f0",
		mobileNavigation: "#1c1c1c",
		layout: "#151515",
		mobileIconHover: "#b5262f",
		mobileLinkActive: "#575757",
		active: "#00FFFF",
		authBackground: landingBg,
		prompt: "#0FF0FF",
	},
	button: {
		primary: {
			color: "#202020",
			background: "#FF00FF",
			borderColor: "#FF00FF",
			disabledColor: "#FFFFFF",
			disabledBackground: "#202020",
			disabledBorderColor: "#202020",
			hoverColor: "#fff",
			hoverBackground: "#A408A4",
			hoverBorderColor: "#A408A4",
			fontWeight: "bold",
		},
		secondary: {
			color: "#202020",
			background: "#00FFFF",
			borderColor: "#00FFFF",
			disabledColor: "#ffffff",
			disabledBackground: "#202020",
			disabledBorderColor: "#202020",
			hoverColor: "#ffffff",
			hoverBackground: "#068080",
			hoverBorderColor: "#068080",
			fontWeight: "bold",
		},
		tertiary: {
			color: "#ffffff",
			background: "transparent",
			borderColor: "#ffffff",
			disabledColor: "#b6b6b6",
			disabledBackground: "transparent",
			disabledBorderColor: "#b6b6b6",
			hoverColor: "#f3f3f3",
			hoverBackground: "transparent",
			hoverBorderColor: "#f3f3f3",
			fontWeight: "bold",
		},
		primaryDark: {
			color: "#ffffff",
			background: "#202020",
			borderColor: "#202020",
			disabledColor: "#ffffff",
			disabledBackground: "#373737",
			disabledBorderColor: "#373737",
			hoverColor: "#fff",
			hoverBackground: "#2d2d2d",
			hoverBorderColor: "#2d2d2d",
			fontWeight: "bold",
		},
	},
	typography: {
		fontFamily: fontFamily,
	},
	breakpoints: {
		values: {
			mobile: 768,
			tablet: 960,
			desktop: 1200,
			large_desktop: 1440,
		},
	},
};

type ITheme = typeof themeObject;
export const theme = createTheme(themeObject);

/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/naming-convention */

declare module "@mui/material/styles" {
	/**
	 *Disabled as it's allowing to avoid `any` type per MUI documentation
	 * https://mui.com/material-ui/customization/theming/#custom-variables
	 */

	// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-empty-interface
	interface Theme extends ITheme {}

	interface BreakpointOverrides {
		xs: false; // removes the `xs` breakpoint
		sm: false;
		md: false;
		lg: false;
		xl: false;
		mobile: true; // adds the `mobile` breakpoint
		tablet: true;
		desktop: true;
		large_desktop: true;
	}
}

declare module "@emotion/react" {
	/**
	 *Disabled as it's allowing to avoid `any` type per Emotion documentation
	 * https://emotion.sh/docs/typescript#define-a-theme
	 */

	// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-empty-interface
	interface Theme extends ITheme {}
}
